<template>
  <label class="checkbox">
    <input type="checkbox" v-model="value" class="checkbox__input" />
    <div class="checkbox__fake-box"></div>
    <div class="checkbox__label">{{ label }}</div>
  </label>
</template>

<script>
export default {
  name: "Checkbox",
  data() {
    return {
      value: false
    };
  },
  props: {
    label: {
      type: String,
      required: true
    }
  },
  watch: {
    value: function(val) {
      this.$emit("value", val, this.label);
    }
  }
};
</script>

<style lang="scss" scoped>
.checkbox {
  $_parent: &;
  align-items: center;
  border-radius: sizes("border-radius");
  cursor: pointer;
  display: flex;
  padding: spacer("s");
  transition: cta-transition(background-color, 0.3s);

  &__input {
    height: 0;
    opacity: 0;
    width: 0;
  }

  &__fake-box {
    $_size: 18px;
    align-items: center;
    background-color: theme-color("body");
    border-radius: sizes("border-radius-s");
    border: 1px solid theme-color("border");
    box-shadow: theme-color("shadow");
    display: flex;
    height: $_size;
    justify-content: center;
    margin-right: spacer("s");
    min-height: $_size;
    min-width: $_size;
    position: relative;
    transition: cta-transition(background-color, 0.2s);
    width: $_size;

    &::after {
      $_dot-transition: opacity, transform;
      background-color: theme-color("accent-2");
      border-radius: sizes("border-radius-s") * 0.6;
      content: "";
      height: 10px;
      opacity: 0;
      transform: scale(0);
      transition: cta-transition($_dot-transition, 0.4s);
      width: 10px;
    }
  }

  &__input:checked + &__fake-box::after {
    opacity: 1;
    transform: scale(1);
  }

  &__input:focus + &__fake-box,
  &__input:active + &__fake-box {
    box-shadow: theme-color("shadow-focus");
  }

  &__label {
    color: theme-color("body");
    font-size: px-to-rem(16px);
    pointer-events: none;
  }

  @include if-tablet {
    &:hover {
      background-color: rgba(theme-color("body"), 0.1);
    }
  }
}
</style>
